export const data = {
    name: "Plugs",
    layout: [],
};
export default data;